var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.555 13.168L7.555 3.16796C7.248 2.96396 6.853 2.94396 6.529 3.11796C6.203 3.29196 6 3.63096 6 3.99996V24C6 24.369 6.203 24.708 6.528 24.882C6.676 24.961 6.838 25 7 25C7.194 25 7.388 24.943 7.555 24.832L22.555 14.832C22.833 14.646 23 14.334 23 14C23 13.666 22.833 13.354 22.555 13.168Z",
  fill: "currentColor"
})));
export default SvgPlay28;